export default __webpack_public_path__ + "static/media/3105.136aa954.png";